<template>
  <div>
    <!-- 教育培训 -->
    <nav-common :nav="nav"></nav-common>
    <div class="center-intro">
      <div class="center-intro-content">
        <div class="education-list">
          <list-item
            v-for="item in personList"
            :key="'per'+item.id"
            :itemData="item"
            @toPage="getDetail"
          ></list-item>
        </div>
      </div>
    </div>
    <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
  </div>
</template>
<style scoped>
.center-intro {
  width: 100%;
  background: #e6ecf2;
  border: 1px solid #e6ecf2;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.center-intro-content {
  width: 100%;
  background: #fff;
  color: #222;
  padding: 0 40px 20px 20px;
  box-sizing: border-box;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import ModelPage from "@/components/views/common/ModelPage";
import listItem from "@/components/views/common/listItem";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: {
        firsttitle: "党建专题",
        firstrouteName: "brecruitment",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      search_word: "",
      ariList: [], //分页所需的值
      personList: [],
      page: 1,
      count: 10
    };
  },
  mounted() {
    this.getBuildingList();
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  methods: {
    ...mapActions(["setSearch"]),
    getDetail(id) {
      this.$router.push({
        name: "breDetails",
        query: {
          id: id
        }
      });
    },
    getBuildingList() {
      const params = {
        type: 2,
        page: this.page,
        count: this.count,
        search_word: this.search_word
      };
      userApi.getBuildingList(params).then(res => {
        this.ariList = res.data;
        this.personList = res.data.list;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "articleDetails",
            query: {
              id: this.personList[0].id
            }
          });
        }
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getBuildingList();
    }
  },
  watch: {
    searchVuex(newArr, oldArr) {
      this.search_word = newArr;
      if (this.search_word == "") {
        this.getBuildingList();
      }
      this.getBuildingList();
    }
  },
  components: {
    navCommon,
    ModelPage,
    listItem
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/BuildingList/Children/recruitment.vue